import { css as c, LitElement as m, html as g } from "lit";
import { property as p, customElement as d } from "lit/decorators.js";
import "@smartdesign/button";
import { classMap as h } from "lit/directives/class-map.js";
const b = "data:image/svg+xml,%3csvg%20width='16'%20height='16'%20viewBox='0%200%2016%2016'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M3.75%203.75L12.25%2012.25M12.25%203.75L3.75%2012.25'%20stroke='%23767676'%20stroke-width='1.2'/%3e%3c/svg%3e";
var f = Object.defineProperty, u = Object.getOwnPropertyDescriptor, o = (n, a, s, r) => {
  for (var t = r > 1 ? void 0 : r ? u(a, s) : a, i = n.length - 1, l; i >= 0; i--)
    (l = n[i]) && (t = (r ? l(a, s, t) : l(t)) || t);
  return r && t && f(a, s, t), t;
};
let e = class extends m {
  constructor() {
    super(...arguments), this.message = "", this.messageAppButton = "Open", this.url = "", this.icon = "", this.verticalAlignment = "";
  }
  render() {
    const n = h({
      "app-banner": !0,
      "app-banner-on-top": this.verticalAlignment == "top",
      "app-banner-on-bottom": this.verticalAlignment == "bottom"
    });
    return g`<div class="${n}">
            <div id="app-banner-close-action" @click="${this.closeBanner}">
                <img src="${b}" alt="Close cross icon" />
            </div>
            <a id="app-banner-open-action" href="${this.url}">
                <img src="${this.icon}" alt="Application logo" />
                <div class="app-banner-message-div">${this.message}</div>
                <div class="app-banner-open-text">${this.messageAppButton}</div>
            </a>
        </div>`;
  }
  closeBanner() {
    const n = this.shadowRoot.host;
    n.style.display = "none";
  }
};
e.ID = "sd-app-banner";
e.styles = c`
        img {
            display: block;
            margin: auto;
        }

        .app-banner {
            font-family: "Segoe UI", "Lucida Sans", "Arial", sans-serif;
            background-color: #f1f1f1;
            border-radius: 5px;
            box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.3);
            margin: 20px;
            display: grid;
            grid-template-columns: 0fr 1fr;
            align-items: center;
        }
        .app-banner-on-top {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
        }
        .app-banner-on-bottom {
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
        }

        #app-banner-close-action {
            display: grid;
            height: 100%;
            padding: 0 10px 0 10px;
            cursor: pointer;
            color: black;
            text-decoration: none;
        }
        #app-banner-open-action {
            display: grid;
            grid-template-columns: 0fr auto auto;
            align-items: center;
            padding: 10px 10px 10px 0;
            column-gap: 5px;
            cursor: pointer;
            color: black;
            text-decoration: none;
        }

        .app-banner-message-div {
            white-space: normal;
            font-size: 0.87em;
            font-weight: 500;
            white-space: normal;
        }

        .app-banner-open-text {
            color: #2980b9;
            font-size: 1.1em;
            font-weight: bold;
            justify-self: right;
            padding-right: 10px;
        }
    `;
o([
  p()
], e.prototype, "message", 2);
o([
  p()
], e.prototype, "messageAppButton", 2);
o([
  p()
], e.prototype, "url", 2);
o([
  p()
], e.prototype, "icon", 2);
o([
  p()
], e.prototype, "verticalAlignment", 2);
e = o([
  d("sd-app-banner")
], e);
export {
  e as AppBanner
};
//# sourceMappingURL=app-banner.mjs.map
